import { render, staticRenderFns } from "./TableAssetInfo.vue?vue&type=template&id=e51011f6&scoped=true"
import script from "./TableAssetInfo.vue?vue&type=script&lang=js"
export * from "./TableAssetInfo.vue?vue&type=script&lang=js"
import style0 from "./TableAssetInfo.vue?vue&type=style&index=0&id=e51011f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51011f6",
  null
  
)

export default component.exports